import { render } from "./FullScreenAudio.vue?vue&type=template&id=3d885ad6"
import script from "./FullScreenAudio.vue?vue&type=script&lang=js"
export * from "./FullScreenAudio.vue?vue&type=script&lang=js"

import "./FullScreenAudio.vue?vue&type=style&index=0&id=3d885ad6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__